import { render, staticRenderFns } from "./claimRecord.vue?vue&type=template&id=370cc895&scoped=true"
import script from "./claimRecord.vue?vue&type=script&lang=js"
export * from "./claimRecord.vue?vue&type=script&lang=js"
import style0 from "./claimRecord.vue?vue&type=style&index=0&id=370cc895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370cc895",
  null
  
)

export default component.exports